import {AppCategory} from '@web-landing/api/fetchCategories';

const categoriesTranslates = {
  en: {
    games: {
      casual: 'Casual',
      puzzle: 'Puzzle',
      sports: 'Sports',
      simulator: 'Simulator',
      shooter: 'Shooter',
      rolePlaying: 'Role playing',
      action: 'Action',
      arcade: 'Arcade',
      adventure: 'Adventure',
      boardAndCard: 'Board and card',
      children: 'Children',
      race: 'Race',
      word: 'Word',
      quiz: 'Quiz',
      utilities: 'Utilities',
      paid: 'Paid',
      casino: 'Casino',
      music: 'Music',
      ar: 'AR',
      indie: 'Indie',
      board: 'Board',
      card: 'Card',
      strategy: 'Strategy',
      family: 'Family',
    },
    apps: {
      entertainment: 'Entertainment',
      foodAndDrink: 'Food and drink',
      parenting: 'Parenting',
      lifestyle: 'Lifestyle',
      education: 'Education',
      social: 'Social',
      news: 'News',
      medicine: 'Medicine',
      adsAndServices: 'Ads and Services',
      pets: 'Pets',
      health: 'Health',
      purchases: 'Purchases',
      tools: 'Tools',
      travelling: 'Travelling',
      books: 'Books',
      sport: 'Sport',
      transport: 'Transport',
      gambling: 'Gambling',
      finance: 'Finance',
      state: 'State',
      business: 'Business',
    },
  },
  zh: {
    games: {
      casual: '休闲游戏',
      puzzle: '益智游戏',
      sports: '体育竞技游戏',
      simulator: '模拟',
      shooter: '射击游戏',
      rolePlaying: '角色扮演',
      action: '动作游戏',
      arcade: '街机游戏',
      adventure: '冒险',
      boardAndCard: '棋盘和纸牌游戏',
      children: '儿童游戏',
      race: '赛车游戏',
      word: '文字游戏',
      quiz: '测验',
      utilities: '实用程序',
      paid: '付费游戏',
      casino: '赌场',
      music: '音乐游戏',
      ar: '带AR的游戏',
      indie: '独立游戏',
      board: '桌面游戏',
      card: '卡牌',
      strategy: '策略游戏',
      family: '家庭',
    },
    apps: {
      entertainment: '娱乐',
      foodAndDrink: '食品和饮料',
      parenting: '家长版',
      lifestyle: '生活方式',
      education: '教育',
      social: '社交通讯',
      news: '新闻和事件',
      adsAndServices: '广告和服务',
      pets: '宠物',
      health: '健康',
      purchases: '购物',
      tools: '实用工具',
      travelling: '旅行',
      books: '书籍',
      sport: '体育竞技游戏',
      transport: '交通和导航',
      gambling: '投注和彩票',
      finance: '金融',
      state: '政府',
      business: '商务服务',
    },
  },
} as Record<'en' | 'zh', Record<'apps' | 'games', Record<string, string>>>;

export const getMappedTranslates = (
  categories: AppCategory[],
  type: 'apps' | 'games',
  language: 'en' | 'zh',
) => {
  return categories
    .map((item) => ({
      ...item,
      categoryName:
        categoriesTranslates[language][type][item.category] || false,
    }))
    .filter((item) => item.categoryName);
};
